import jwtAuthAxios from "../../../services/jwtAuth";
import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit';

export const getBillingInfo = createAsyncThunk("billing/get", async(val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/billing/information/trxid/${val}`);
    return response.data;
});

// tanggal pembayaran xendit diambil dari payment.xen_fva_paid (external_id = trx_id)
export const getXenFvaPaid = createAsyncThunk("billing/getXenFvaPaid", async(val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/xen-fva-paid/trx/${val}`);
    return response.data;
});

const initialState = {
    loadingBillingInfo : false,
    responseBillingInfo : {},
    loadingXenFvaPaid : false,
    responseXenFvaPaid : {}
}

const billingInfoSlice = createSlice({
    name:"paySlice",
    initialState: initialState,
    extraReducers: {
        [getBillingInfo.pending] : (state, action) => {
            state.loadingBillingInfo = true;
        },
        [getBillingInfo.fulfilled] : (state, action) => {
            state.responseBillingInfo = action.payload;
            state.loadingBillingInfo = false;
        },
        [getBillingInfo.rejected] : (state, action) => {
            state.loadingBillingInfo = false;
        },
        [getXenFvaPaid.pending] : (state, action) => {
            state.loadingXenFvaPaid = true;
        },
        [getXenFvaPaid.fulfilled] : (state, action) => {
            state.responseXenFvaPaid = action.payload;
            state.loadingXenFvaPaid = false;
        },
        [getXenFvaPaid.rejected] : (state, action) => {
            state.loadingXenFvaPaid = false;
        },
    }
})

export const billingInfoSelector = (state) => state.billingInfo;
export default billingInfoSlice.reducer;